import { render, staticRenderFns } from "./AiPromptTemplates.vue?vue&type=template&id=98ebd998"
import script from "./AiPromptTemplates.vue?vue&type=script&lang=js"
export * from "./AiPromptTemplates.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports